<template>
    <div class="alarmSignal">
        <el-tabs v-model="activeTabs" @tab-click="handleChange">
            <el-tab-pane :label="tabsItem.label" :name="tabsItem.name" v-for="tabsItem in tabs" :key="tabsItem.label">
                <div class="imgGroup">
                    <img :src="baseApi + '/designs/images/alarmicon/' + item + '.gif'" alt="" v-for="(item, index) in imgGroup" :key="index" @click="changeImgIndex($event, index)">
                </div>
                <div class="list" v-if="activeTabs == 'list'">
                    <ul>
                        <li v-for="(areaItem, key, areaItemIndex) in dataObj" :key="areaItemIndex">
                            <div class="areaName">{{key}}</div>
                            <div class="block" v-for="(colorItem,index) in 4" :key="index" :style="'background-color:' + (areaItem[colorItem-1] == undefined ? '#f0f0f0' : areaItem[colorItem-1]) + ';'"></div>
                        </li>
                    </ul>
                </div>
                <div class="state" v-if="activeTabs == 'state'">
                    <img :src="baseApi +'/data/alarm/'+ stateImgUrlGroup[imgGroupIndex]" alt="" class="stateImg">
                    <ul>
                        <li v-for="(areaItem, key, areaItemIndex) in dataObj" :key="areaItemIndex">
                            <div class="block" :style="'background-color:' + (areaItem[imgGroupIndex] == undefined ? '#f0f0f0' : areaItem[imgGroupIndex]) + ';'"></div>                            
                            <div class="areaName">{{key}}</div>
                        </li>
                    </ul>
                </div>
            </el-tab-pane>
        </el-tabs>
        <a href="#" @click="navigatoAlarm">点击查看预警防御指引</a>
    </div>
</template>

<script>
import { home } from '../../api/index'
export default {
    created() {
        this.baseApi = process.env.VUE_APP_BASE_API;
        home.getGZ_areaAlarm().then(data => {
            for(let key in data) {
                this.imgGroup.push(data[key].signame + data[key].sigcolor);
                this.stateImgUrlGroup.push(data[key].pic);
                data[key].areas.forEach((item, index) => {
                    for(let i = 0; i < this.cityGroup.length; i++) {
                        if(this.dataObj[this.cityGroup[i]] == undefined) {
                            this.dataObj[this.cityGroup[i]] = [];
                        }
                        if(item == this.cityGroup[i]) {
                            this.dataObj[item].push(data[key].areasColor[index]);
                        }
                    }
                })
            }
        })
    },
    data() {
        return {
            // 接口url
            baseApi: '',

            // 预警图片数组
            imgGroup: [],

            // 当前预警图片的下标
            imgGroupIndex: 0,

            // 状态图url
            stateImgUrlGroup: [],

            // 区域名数组
            cityGroup: [
                '越秀',
                '海珠',
                '荔湾',
                '天河',
                '黄埔',
                '白云',
                '花都',
                '番禺',
                '南沙',
                '从化',
                '增城',
            ],

            // 封装每个区域的数据结构
            dataObj: {},

            // 当前激活tabs项
            activeTabs: 'list',

            // tabs头部渲染
            tabs: [{
                label: '列表',
                name: 'list'
            },{
                label: '状态图',
                name: 'state'
            }]
        }
    },
    methods: {
        handleChange() {},

        changeImgIndex($event, value) {
            this.imgGroupIndex = value
        },

        navigatoAlarm($event) {
            $event.preventDefault();
            location.href="http://tqyb.com.cn/gz/weatherAlarm/guide/";
        }
    }
}
</script>

<style lang="less">
    .alarmSignal {
        position: relative;
        width: 300px;   
        margin: 0 auto; 
        .imgGroup {
            img {
              margin-right: 10px;  
            }
        }
        .list {
            li {
                display: flex;
                justify-content: space-evenly;
                align-items: flex-start;
                padding: 2px 0;
                font-size: 14px;
                .block {
                    width: 61px;
                    height: 18px;
                }
            }

            li:hover {
                background-color: skyblue;
            }
        }
        .state {
            display: flex;
            justify-content: space-evenly;
            .stateImg {
                width: 200px;
                height: 250px;
            }
            li {
                display: flex;
                justify-content: space-evenly;
                align-items: center;
                margin: 2px 0;
                font-size: 14px;
                .block {
                    width: 20px;
                    height: 10px;
                    margin-right: 5px;
                }
            }
        }
        a {
            position: absolute;
            top: 10px;
            right: 0;
            font-size: 14px;
        }
    }

</style>